import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ServiceTemplateDataElement } from 'src/app/models/interface/serviceTemplate/serviceTemplateDataElement';
import { MAP_TARGET_SERVICE_TEMPLATE_STATUS } from 'src/app/utils/Constants';

@Component({
  selector: 'app-dialog-change-service-template-status',
  templateUrl: './dialog-change-service-template-status.component.html',
  styleUrls: ['./dialog-change-service-template-status.component.scss']
})
export class DialogChangeServiceTemplateStatusComponent implements OnInit {

  translatedStatus: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceTemplateDataElement,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getTargetStatus();
  }

  private getTargetStatus() {
    const currentStatus = this.data.element.state;
    const status = MAP_TARGET_SERVICE_TEMPLATE_STATUS['' + currentStatus];
    this.translateStatus(status);
  }

  private translateStatus(status: string) {
    this.translate.get('SERVICE_TEMPLATES_STATUS.' + status).subscribe((translated: string) => {
      this.translatedStatus = translated;
    });
  }

}
